import { createContext } from 'react'
import { defaultColumnManagerContext, IColumnManagerContext } from 'src/interfaces/columnManager'

export interface IMCsTableContext extends IColumnManagerContext {
  tagsFilter: Array<string>
  setTagsFilter(tagsFilter: Array<string>): void

  refreshMCs(): Promise<void>
}

export const MCsTableContext = createContext<IMCsTableContext>({
  ...defaultColumnManagerContext,

  tagsFilter: [],
  setTagsFilter: () => {},

  refreshMCs: async () => {},
})
